import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import {
  createComplexDocument,
  getWelcomeDocument,
  patchComplexDocument,
} from '../../utils/services/complexDocumentsAPI';
import ComplexDocumentHistoryProvider, {
  useDocumentContext,
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
} from '../../context/complexDocumentContext';
import { importVariables } from '../../utils/importHelper';
import { modifyMasterTemplateFlows } from '../../utils/masterTemplateHelper';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import { createCategory } from '../../utils/services/categoriesAPI';
import SaasSetupLoader from './SaasSetupLoader';

const DEFAULT_CATEGORY_NAME = 'Default';

const ImportWelcomeTemplate = () => {
  const contextSelector = useCallback(store => store, []);
  const [documentContext, store] = useDocumentContext(contextSelector);

  const history = useHistory();

  const importDefaultTemplate = async () => {
    // Fetch team id
    let teamId = null;
    const teamAPIResponse = await getGroupPermission(true);
    if (teamAPIResponse?.statusCode === 1410) {
      teamId = teamAPIResponse?.data[0]?.rgId;
    }
    // Create default cateogry
    const defaultCategory = { name: DEFAULT_CATEGORY_NAME, type: 'template' };
    const categoryAPIResponse = await createCategory(defaultCategory);
    let categoryId = null;
    if (categoryAPIResponse?.statusCode === 501) {
      categoryId = categoryAPIResponse?.id;
    }

    if (!teamId || !categoryId) return false;

    let masterTemplateResponse = await getWelcomeDocument();
    if(masterTemplateResponse?.statusCode !== 707) return;
    
    let globalVariables = documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.GLOBAL_VARIABLES];
    let flows = masterTemplateResponse?.data[0]?.documentDTO.flows;
    let variables = masterTemplateResponse?.data[0]?.variables;
    // const style = masterTemplate.style;

    const templateName = masterTemplateResponse?.data[0]?.name || 'Welcome Document';
    const payload = {
      categoryId: categoryId,
      resourceGroupId: teamId,
      communicationId: null,
      displayName: templateName,
      variableContract: [],
      style: {
        fontFamily: 'Open Sans',
        fontSize: 16,
      },
      documentName: templateName,
      flows: [
        {
          orderNumber: 1,
          flowName: '',
          style: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            width: 794,
            height: 1123,
            backgroundColor: '#ffffff',
            pageNumber: {
              contents: {
                style: {
                  width: 60,
                  height: 24,
                  x: 0,
                  y: 0,
                },
                contentType: 'text',
              },
            },
          },
          paperSize: 'a4',
          paperOrientation: 'portrait',
          header: null,
          footer: null,
          blocks: [],
        },
      ],
    };

    const response = await createComplexDocument(payload, true);
    if (response?.statusCode !== 701) {
      return false;
    }


    const variableIdMap = await importVariables(variables, globalVariables, store);
    const uploadedUrlsMap = new Map();
    const blBlocks = [];

    await modifyMasterTemplateFlows(flows, blBlocks, variableIdMap, uploadedUrlsMap, false);

    const updateDocumentFlow = [
      ...flows,
      {
        flowId: response?.data.flowId,
        isDeleted: true,
        isStandalone: false,
      },
    ];

    const updateDocument = {
      documentName: templateName,
      documentId: response?.data.documentId,
      flows: updateDocumentFlow,
      style: masterTemplateResponse.data[0].documentDTO.style,
    };

    await patchComplexDocument(updateDocument, undefined, null, false, false, false);
    return true;
  };

  return (
    <SaasSetupLoader
      createDefaultTemplate={importDefaultTemplate}
      onSuccess={() => history.push('/documentTemplates')}
    />
  );
};

const InitialSetup = () => {
  return (
    <ComplexDocumentHistoryProvider>
      <ImportWelcomeTemplate />
    </ComplexDocumentHistoryProvider>
  );
};

export default InitialSetup;
